import * as React from "react";
import { Input, Col, Form, Checkbox, Row } from "antd";

import { FormInstance } from "antd/lib/form";
import TextArea from "antd/lib/input/TextArea";
import { DocumentTypes } from "../../../core/common/Constants";
import { IDocumentType } from "../../../documentTypes/model/DocumentType";

const FormFields = {
  CODE: "code",
  DESCRIPTION: "description",
  NAME: "name",
  ID: "id",
  TYPE: "type",
  VALID: "valid"
};

const CaseLawDocumentTypeForm = ({
  translate,
  form,
  rowData
}: {
  translate: any;
  form: FormInstance;
  rowData?: IDocumentType;
}) => {
  return (
    <Form layout={"vertical"} form={form}>
      <Form.Item
        name={FormFields.ID}
        initialValue={rowData?.id}
        style={{ display: "none" }}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name={FormFields.TYPE}
        initialValue={rowData?.type ?? DocumentTypes.CASE_LAW_DOCUMENT_TYPE}
        style={{ display: "none" }}
      >
        <Input value={DocumentTypes.CASE_LAW_DOCUMENT_TYPE} />
      </Form.Item>
      <Row gutter={16} className={"content-section-modal-emphasize"}>
        <Col lg={22} sm={21} xs={20}>
          <Form.Item
            label={translate("editors.case_law_document_types.code")}
            className={"mb-0"}
            name={FormFields.CODE}
            initialValue={rowData?.code}
            rules={[
              {
                required: true,
                message: translate(
                  "editors.case_law_document_types.required_messages",
                  {
                    field: translate("editors.case_law_document_types.code")
                  }
                )
              }
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col
          lg={2}
          sm={3}
          xs={4}
          style={{
            display: "flex",
            marginTop: 20,
            alignItems: "center"
          }}
        >
          <Form.Item
            label={translate("editors.case_law_document_types.valid")}
            className={"png-form-item-horizontal-checkbox mb-0"}
            name={FormFields.VALID}
            valuePropName={"checked"}
            initialValue={rowData?.valid ?? true}
          >
            <Checkbox />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16} className={"content-section-modal-borderless pb-0"}>
        <Col xs={24} sm={24}>
          <Form.Item
            label={translate("editors.case_law_document_types.name")}
            name={FormFields.NAME}
            initialValue={rowData?.name}
            rules={[
              {
                required: true,
                message: translate(
                  "editors.case_law_document_types.required_messages",
                  {
                    field: translate("editors.case_law_document_types.name")
                  }
                )
              }
            ]}
          >
            <Input />
          </Form.Item>
        </Col>

        <Col xs={24} sm={24}>
          <Form.Item
            className={"mb-0"}
            label={translate("editors.case_law_document_types.description")}
            name={FormFields.DESCRIPTION}
            initialValue={rowData?.description}
          >
            <TextArea />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default CaseLawDocumentTypeForm;
